import { useTranslation } from 'react-i18next';

import defaultProductImage from 'assets/images/default-product-image.png';

import { RefundItemStorageModel } from 'types/pwcOrder';

import { KEYS } from '../../../keys';
import { OrderItemDetails, OrderItemImage, OrderItemName } from '../../styles';

export const OrderItem = ({ name, imageUrl, fiatAmount, currency }: RefundItemStorageModel & { currency: string }) => {
  const { t } = useTranslation();

  return (
    <OrderItemDetails>
      <OrderItemImage src={imageUrl || defaultProductImage} alt={name} /> <OrderItemName>{name}</OrderItemName> {t(KEYS.DASH)}
      <span>
        {fiatAmount} {currency.toUpperCase()}
      </span>
    </OrderItemDetails>
  );
};
